module.exports = __webpack_public_path__ + "static/media/awesome-experience.2b0d1361.jpg";